export default "__VITE_ASSET__DsjILD0A__"